import { Injectable } from '@angular/core';
import {Subject} from 'rxjs';
import {ScopeService} from './scope.service';

@Injectable({
  providedIn: 'root'
})
export class HttpCancelService {
  private cancelPendingRequests$ = new Subject<void>();

  constructor() {
  }

  public cancelPendingRequests() {
    this.cancelPendingRequests$.next();
  }

  public onCancelPendingRequests() {
    return this.cancelPendingRequests$.asObservable();
  }
}
